document.addEventListener('DOMContentLoaded', function() {
  // Initialize cart drawer
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const closeButton = document.querySelector('.cart-drawer__close');
  
  // Open cart drawer
  function openCartDrawer() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    loadCartItems();
  }
  
  // Close cart drawer
  function closeCartDrawer() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  // Load cart items
  function loadCartItems() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemsContainer = document.querySelector('.cart-drawer__items');
        itemsContainer.innerHTML = '';
        
        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<p>Your cart is empty</p>';
          return;
        }
        
        cart.items.forEach(item => {
          const itemElement = document.createElement('div');
          itemElement.className = 'cart-item';
          
          const imageUrl = item.image ? item.image : '{{ "placeholder-image.jpg" | asset_url }}';
          
          itemElement.innerHTML = `
            <div class="cart-item__image">
              <img src="${imageUrl}" alt="${item.title}" width="80">
            </div>
            <div class="cart-item__details">
              <h4 class="cart-item__title">${item.title}</h4>
              <p class="cart-item__variant">${item.variant_title}</p>
              <p class="cart-item__price">Rs.${(item.price / 100).toFixed(2)}</p>
            </div>
          `;
          
          itemsContainer.appendChild(itemElement);
        });
        
        // Update total price
        document.querySelector('.cart-drawer__total-price').textContent = `Rs.${(cart.total_price / 100).toFixed(2)}`;
      });
  }
  
  // Event listeners
  closeButton.addEventListener('click', closeCartDrawer);
  cartOverlay.addEventListener('click', closeCartDrawer);
  
  // Handle all add to cart forms
  document.addEventListener('submit', function(e) {
    if (e.target && e.target.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(e.target)
      })
      .then(response => response.json())
      .then(() => {
        openCartDrawer();
        updateCartCount();
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  });
  
  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('.cart-count');
        cartCounts.forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }
});